import { axiosInstance } from '@/lib/axios'
import {
  PreCalculateDriversRequestArgs,
  PreCalculateDriversResponsePayload,
} from './types'

export function requestPrecalculateDrivers(
  props: PreCalculateDriversRequestArgs,
) {
  const { companyId } = props
  return axiosInstance.post<PreCalculateDriversResponsePayload>(
    `/api/${companyId}/timesheet/precalculate`,
    props,
  )
}
